// @flow
import React from 'react';
import { FileField } from '@src/formik-utils/FormFields';
import { CE1_BASELINE_IMPORT_CONFIG_MAP } from '@components/ce1-baseline/config';

export const CE1BaselineInputFileContainer = ({ disableOnFormErrors = null }) => {
  const { backendFieldName, displayName, tooltip } =
    CE1_BASELINE_IMPORT_CONFIG_MAP.get('input_file');

  return (
    <FileField
      accept=".csv"
      disableOnFormErrors={disableOnFormErrors}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      fluid={true}
      tooltip={tooltip}
    />
  );
};
